import React, { useEffect, useState } from 'react';
import Layout from '../../../Components/layout/Layout';
import RoleComponent from './component/RoleComponent';
import Modal from 'react-modal';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { MdDelete } from 'react-icons/md';
import {
  api,
  getAllFolders,
  getPreSelectProcedures,
  getProcedureByFolder,
} from '../../../Api-Endpoints/apiEndpoint';
import Select from 'react-select';

import {
  _addRole,
  _roleDeletedSuccess,
  _updateRoleSuccess,
} from '../../../Redux/RoleSlice';
import toast from 'react-hot-toast';
import {
  LoadProcedureOnRequest,
  LoadProcedures,
  LoadProceduresRequest,
  ResetProcedure,
} from '../../../Redux/ProcedureReducer';
import MiniLoader from '../../../Components/loader/MiniLoader';
import RoleSelection from './component/roleSelections';
import ProcedureSelection from './component/procedureSelection';
import DeleteModal from '../../../Components/Modal/DeleteModal';
import { IoMdCloseCircleOutline } from 'react-icons/io';
import ProcedureSelector from './component/procedureSelection';
function Role() {
  const dispatch = useDispatch();
  const {
    procedure_on_request,
    procedures,
    isLoading,
    isGotProcedure,
    loggedOrg,
    _roles,
    user,
    folders,
  } = useSelector(
    state => ({
      procedure_on_request: state.Procedure.procedure_on_request,
      procedures: state.Procedure.procedures,
      isLoading: state.Procedure.isLoading,
      isGotProcedure: state.Procedure.isGotProcedure,
      loggedOrg: state.Organization.loggedOrg,
      _roles: state.Roles._roles,
      user: state.User.user,
      folders: state.Folder.folders,
    }),
    shallowEqual
  );
  const [openRoleCreate, setOpenRoleCreate] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [ids, setIds] = useState('');
  const [editPrev, setEditPrev] = useState({});
  const [openConfirmModel, setOpenConfirmModel] = useState(false);
  const [prevData, setPrevData] = useState({
    name: '',
    procedures: [],
  });

  const [newFolders, setNewFolders] = useState([]);
  const [newFirstFolders, setNewFirstFolders] = useState([]);
  const [newSubFolders, setNewSubFolders] = useState([]);
  const [newProcedures, setNewProcedures] = useState([]);
  const [procedureIds, setProcedureIds] = useState([]);

  const getFolders = async () => {
    const res = await getAllFolders();
    if (res?.success === true) {
      setNewFirstFolders(res?.folders?.filter(folder => !folder.parent));
      setNewFolders(res?.folders);
    }
  };
  useEffect(() => {
    getFolders();
  }, []);
  useEffect(() => {
    if (isGotProcedure) {
      dispatch(ResetProcedure());
    }
  }, [isGotProcedure]);

  const handleProcedureSelect = selectedProcedure => {
    setPrevData(prev => {
      const existingProcedureIndex = prev.procedures.findIndex(
        p =>
          p.id === selectedProcedure._id ||
          p.procedure?._id === selectedProcedure._id
      );

      if (existingProcedureIndex !== -1) {
        // If the procedure is already selected, remove it
        const updatedProcedures = prev.procedures.filter(
          (_, index) => index !== existingProcedureIndex
        );
        return { ...prev, procedures: updatedProcedures };
      } else {
        // If the procedure is not selected, add it
        const newProcedure = {
          id: selectedProcedure._id,
          name: selectedProcedure.name,
        };
        return { ...prev, procedures: [...prev.procedures, newProcedure] };
      }
    });
  };

  const onConfirmEditPrevilliage = () => {
    setPrevData({ ...editPrev });
    setOpenConfirmModel(false);
    setOpenRoleCreate(true);
  };
  const onCancelEditPrevilliage = () => {
    setEditPrev({});
    setIds('');
    // setPrevData({
    //   name: "",
    //   screen: {
    //     canCreate: false,
    //     canEdit: false,
    //     canDelete: false,
    //   },
    //   content: {
    //     canCreate: false,
    //     canEdit: false,
    //     canDelete: false,
    //   },
    //   playlist: {
    //     canCreate: false,
    //     canEdit: false,
    //     canDelete: false,
    //   },
    //   folder: {
    //     canCreate: false,
    //     canEdit: false,
    //     canDelete: false,
    //   },
    // });
    setIsEditMode(false);
    setOpenConfirmModel(false);
    setPrevData({
      name: '',
      procedures: [],
    });
  };

  const submitPrevilages = async () => {
    if (!prevData.name) {
      return toast.error('Role Name is required');
    }
    if (procedureIds.length === 0) {
      return toast.error('procedures is required');
    }
    try {
      const { status, data } = await api.post('/role/roleRegister', {
        name: prevData.name,
        userId: user._id,
        // organization: loggedOrg._id,
        procedures: procedureIds,
      });
      if (status === 400) {
        alert('An error occurred: Bad Request');
        return; // Exit early after showing the alert
      }

      if (status === 201) {
        dispatch(_addRole(data.role));
        toast.success('Role Registered.');
        setOpenRoleCreate(false);
        setPrevData({
          name: '',
          procedures: [],
        });
      }
    } catch (error) {
      console.error('Error during role registration:', error);
      toast.error('Role Name Already Exists.');
    }
  };

  const onSubmitEditRole = async () => {
    try {
      const { status, data } = await api.patch(
        `/role/editRoles?roleId=${ids}`,
        {
          role: {
            name: prevData.name,
            procedures: procedureIds,
          },
        }
      );
      if (status == 201) {
        dispatch(_updateRoleSuccess(data.updated));
        setIds('');
        setIsEditMode(false);
        setOpenRoleCreate(false);
        setPrevData({
          name: '',
          procedures: [],
        });
        toast.success('Role updated successfully.');
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const onEditRole = async id => {
    setIds(id);

    // Fetch the pre selected procedures.
    const res = await _roles.find(role => role._id == id);

    setEditPrev({
      name: res?.name,
      procedures: res?.procedures,
    });
    setNewProcedures([]);
    // Enable edit mode and open the modal
    setIsEditMode(true);
    setOpenConfirmModel(true);
  };

  const onEditPrevilliage = id => {
    // console.log(id);
    // setIds(id);
    // const pr = roles.find((p) => p._id == id);
    // Object.keys(pr).forEach((key) => {
    //   if (key == "name") setEditPrev((prev) => ({ ...prev, [key]: pr[key] }));
    //   if (key == "procedure")
    //     setEditPrev((prev) => ({ ...prev, [key]: { ...pr[key] } }));
    //   if (key == "folder")
    //     setEditPrev((prev) => ({ ...prev, [key]: { ...pr[key] } }));
    // });
    // setIsEditMode(true);
    // setOpenConfirmModel(true);
  };
  const onGetProcedureByFolder = async id => {
    try {
      const res = await getProcedureByFolder(id);
      if (res?.success) {
        return res?.procedures;
      }
    } catch (error) {
      console.error(error.message);
    } finally {
      dispatch(ResetProcedure());
    }
  };

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selected, setSelected] = useState('');

  const confirmDeleteModal = async id => {
    setSelected(id);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    onDeleteRole(selected);
  };

  const onDeleteRole = id => {
    api
      .delete(`/role/deleteRole?roleId=${id}`)
      .then(res => {
        if (res.status == 201 && res.data.success) {
          dispatch(_roleDeletedSuccess(id));
          toast.success('Role deleted.');
        }
      })
      .catch(error => {
        toast.error(error?.response?.data?.message);
        console.log(error);
      });
  };

  const handleFolderSelection = async folderId => {
    const res = await onGetProcedureByFolder(folderId);
    setNewProcedures(res);
    setNewSubFolders(newFolders.filter(folder => folder.parent === folderId));
  };
  const handleFolderSubSelection = async folderId => {
    const res = await onGetProcedureByFolder(folderId);
    setNewProcedures([...newProcedures, ...res]);
  };

  const handleSelect = selectedProcedure => {
    const allProceduresSelected = newProcedures.every(newProcedure =>
      prevData.procedures.some(
        selectedProcedure =>
          selectedProcedure.id === newProcedure._id ||
          selectedProcedure.procedure?._id === newProcedure._id
      )
    );
    return allProceduresSelected;
  };

  return (
    <>
      <Layout heading={'Role Management'}>
        <div className="w-[100%] h-[87vh] flex flex-col items-start gap-2 p-2">
          <div className="w-[70%] h-min-[10vh] flex justify-start self-center">
            <button
              className="h-[40px] w-[10%] bg-red-500 text-white rounded-lg border border-red"
              onClick={() => {
                setOpenRoleCreate(true);
                setPrevData({
                  name: '',
                  procedures: [],
                });
                setIsEditMode(false);
                setNewSubFolders([]);
                setNewProcedures([]);
              }}
            >
              Create Role
            </button>
          </div>
          <div className="w-[70%] h-min-[70vh] overflow-y-scroll flex flex-col self-center gap-1">
            {_roles.map((_, index) => (
              <RoleComponent
                key={index}
                role={_}
                onEditRole={onEditRole}
                onDeleteRole={confirmDeleteModal}
              />
            ))}
          </div>
        </div>
      </Layout>

      <Modal
        isOpen={openRoleCreate}
        onRequestClose={() => setOpenRoleCreate(false)}
        contentLabel="Example Modal"
        style={{
          content: {
            width: '55%',
            height: '52%',
            margin: 'auto',
            borderRadius: '20px',
            padding: 0,
          },
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
          },
        }}
      >
        <div className="flex justify-between  mx-5 my-3">
          <div>
            <h1 className="text-2xl font-semibold">Role Manage</h1>
          </div>
          <button onClick={() => setOpenRoleCreate(false)}>
            <IoMdCloseCircleOutline size={20} />
          </button>
        </div>
        <hr />

        <div className="w-[100%] h-[5vh] flex flex-col  justify-center items-start mx-20">
          <label className="w-[100%] h-[5vh] flex flex-col  justify-center items-start pl-5">
            Role name
          </label>
          <input
            type={'text'}
            value={prevData.name}
            name={'name'}
            placeholder="  Role Name"
            onChange={e =>
              setPrevData(prev => ({
                ...prev,
                [e.target.name]: e.target.value,
              }))
            }
            className="h-[100%] w-[80%] border border-black rounded-md pl-2 ml-5"
          />
        </div>
        <div className="h-min-[30vh] w-[100%] flex flex-col items-center mt-1">
          <div className="h-[100%] w-[80%] rounded-md">
            <ProcedureSelector
              prevData={prevData}
              setProcedureIds={setProcedureIds}
              isEditMode={isEditMode}
            />
          </div>
          {/* {newProcedures.length > 0 && (
              <div className="h-[100%] w-[80%] rounded-md mt-4">
                <p>Select Multiple Procedures:</p>
                <div className="max-h-[200px] overflow-y-auto border border-gray-300 rounded-md p-2">
                  <div className="flex items-center mb-2">
                    <input
                      type="checkbox"
                      id="select-all-procedures"
                      checked={handleSelect()}
                      onChange={() => {
                        if (handleSelect()) {
                          setPrevData(prev => ({ ...prev, procedures: [] }));
                        } else {
                          setPrevData(prev => ({
                            ...prev,
                            procedures: newProcedures.map(p => ({ id: p._id, name: p.name }))
                          }));
                        }
                      }}
                      className="mr-2"
                    />
                    <label htmlFor="select-all-procedures"><strong>Select All</strong></label>
                  </div>
                  {newProcedures.map((procedure) => (
                    <div key={procedure._id} className="flex items-center mb-2">
                      <input
                        type="checkbox"
                        id={`procedure-${procedure._id}`}
                        checked={prevData.procedures.some(p => {
                          return p?.id === procedure?._id || p.procedure?._id === procedure._id
                        })}
                        onChange={() => handleProcedureSelect(procedure)}
                        className="mr-2"
                      />
                      <label htmlFor={`procedure-${procedure._id}`}>{procedure.name}</label>
                    </div>
                  ))}
                </div>
              </div>
            )} */}
          {/* <div className="h-[100%] w-[80%] rounded-md"> */}
          {/* <h3>Pre Select</h3>
            <div className="w-full h-[200px] bg-purple-100 border-none rounded-lg p-5 overflow-y-scroll">
              {prevData.procedures.map((_pro, _index) => {
                return (
                  <div className="flex justify-between">
                    <p>{_pro.name || _pro?.procedure?.name}</p>
                    <MdDelete
                      className="cursor-pointer"
                      onClick={() => {
                        setPrevData((prev) => ({
                          ...prev,
                          procedures: prev.procedures.filter(
                            (__pro, __index) => __index !== _index
                          ),
                        }));
                      }}
                    />
                  </div>
                );
              })}
            </div>
          </div> */}

          <div className=" w-[80%] rounded-md flex justify-end my-3 gap-3">
            <button
              onClick={() => {
                setOpenRoleCreate(false);
                setPrevData({
                  name: '',
                  procedures: [],
                });
                setIsEditMode(false);
              }}
              className="border border-red-500 p-1 px-5 rounded-lg"
            >
              Close
            </button>
            <button
              className="border border-red-500 bg-red-500 text-white p-1 px-5 rounded-lg"
              onClick={isEditMode ? onSubmitEditRole : submitPrevilages}
            >
              {isEditMode ? 'Update' : 'Save'}
            </button>
          </div>
        </div>
      </Modal>

      {/* confirmation model */}
      <Modal
        isOpen={openConfirmModel}
        onRequestClose={() => setOpenConfirmModel(false)}
        style={{
          content: {
            width: '25%',
            height: '22%',
            margin: 'auto',
            borderRadius: '20px',
            padding: 0,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          },
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
          },
        }}
      >
        <div className="h-[90%] w-[90%] flex flex-col justify-center items-center gap-5 border border-black">
          <h1 className="text-lg bold">Do you want to edit role?</h1>
          <div className="h-[10%] w-[100%] flex justify-center items-center gap-1">
            <button
              className="h-[3dvh] w-[5dvw] text-white rounded-lg bg-[red]"
              onClick={onConfirmEditPrevilliage}
            >
              Yes
            </button>
            <button
              className="h-[3dvh] w-[5dvw] rounded-lg border border-red-500"
              onClick={onCancelEditPrevilliage}
            >
              No
            </button>
          </div>
        </div>
      </Modal>
      {/* end of confirmation model */}

      <DeleteModal
        showModal={showDeleteModal}
        setShowModal={setShowDeleteModal}
        onConfirm={confirmDelete}
      />
    </>
  );
}

export default Role;
